import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'customer-form-configs'

export default defineStore(
  'customer-form-configs',
  storeModule.createStoreModule('customer-form-configs', {
    fetchSingleURL: url,
    updateURL: url
  })
)
